module.exports = __webpack_public_path__ + "static/media/SemFronteiras.8e7a2b81.png";